import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import '../assets/fonts/fonts.css';

const Navbar = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = document.querySelector('header')?.offsetHeight || 64;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: 'primary.main' }} component="header">
      <Toolbar>
        <Typography variant="h6" component="div" className="csc-title" sx={{ flexGrow: 1, cursor: 'pointer', letterSpacing: '0.5px', fontSize: '1.5rem' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          CSC VTC LUBERON
        </Typography>
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Button 
            color="inherit" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            sx={{ fontFamily: '"Satisfy", cursive', fontSize: '1.1rem' }}
          >
            Accueil
          </Button>
          <Button 
            color="inherit" 
            onClick={() => scrollToSection('services')}
            sx={{ fontFamily: '"Satisfy", cursive', fontSize: '1.1rem' }}
          >
            Services
          </Button>
          <Button 
            color="inherit" 
            onClick={() => scrollToSection('contact')}
            sx={{ fontFamily: '"Satisfy", cursive', fontSize: '1.1rem' }}
          >
            Contact
          </Button>
        </Box>
        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
          <IconButton color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
